export class MonetaryAmount {
  static defaultCurrency = "EUR";

  static ZERO = MonetaryAmount.of(0);

  static INFINITY = MonetaryAmount.of(Number.POSITIVE_INFINITY);

  amountInCents;

  currency;

  constructor(amountInCents, currency) {
    if (
      !Number.isSafeInteger(amountInCents) &&
      (Number.isFinite(amountInCents) || Number.isNaN(amountInCents))
    ) {
      throw new Error("amountInCents must be an integer");
    }

    this.amountInCents = amountInCents;
    this.currency = currency || MonetaryAmount.defaultCurrency;
    this.currency = this.currency.toUpperCase();

    if (
      this.currency !== "EUR" &&
      this.currency !== "GBP" &&
      this.currency !== "MXN"
    )
      throw new Error("Invalid currency");
  }

  static fromUnitary(amount, currency = "EUR") {
    const cents = Math.round(amount * 100);
    return new MonetaryAmount(cents, currency);
  }

  static of(cents, currency = "EUR") {
    return new MonetaryAmount(cents, currency);
  }

  static ofCurrency({ amountInCents, currency }) {
    return new MonetaryAmount(amountInCents, currency);
  }

  zero() {
    return new MonetaryAmount(0, this.currency);
  }

  add(amount) {
    if (this.currency !== amount.currency)
      throw new Error("Incompatible currencies");

    return new MonetaryAmount(
      this.amountInCents + amount.amountInCents,
      this.currency
    );
  }

  subtract(amount) {
    if (this.currency !== amount.currency)
      throw new Error("Incompatible currencies");

    return new MonetaryAmount(
      this.amountInCents - amount.amountInCents,
      this.currency
    );
  }

  multiply(times) {
    // check rounding
    return new MonetaryAmount(
      Math.round(this.amountInCents * times),
      this.currency
    );
  }

  toUnitary() {
    return +(this.amountInCents / 100).toFixed(2);
  }

  equal(amount) {
    return this.amountInCents === amount.amountInCents;
  }

  greaterThan(amount) {
    return this.amountInCents > amount.amountInCents;
  }

  greaterOrEqualThan(amount) {
    return this.amountInCents >= amount.amountInCents;
  }

  formattedToDownload() {
    return Number(this.amountInCents / 100).toFixed(2);
  }

  prettifyMoney({ langTag = "es", maxDecimals = 2 }) {
    let amount = +(this.amountInCents / 100).toFixed(maxDecimals);
    if (this.currency === "GBP") {
      if (langTag === "es")
        amount = `${amount.toString().replace(/\./gi, ",")} GBP`;
      if (langTag === "en") amount = `GBP ${amount}`;
      return amount;
    }
    if (langTag === "es")
      amount = `${amount.toString().replace(/\./gi, ",")} EUR`;
    if (langTag === "en") amount = `EUR ${amount}`;
    return amount;
  }

  prettifyMoneyWithoutSymbol = (locale = "es-ES") =>
    (this.amountInCents / 100).toLocaleString(locale, {
      minimumFractionDigits: 2,
    });
}
